import React, { useContext } from 'react';
import MainContext from '../../../../store/MainContext';
import { Route, Switch } from 'react-router-dom';
import Orders from './Orders';
import Order from './Order/Order';
import Tendering from './Tendering/Tendering';
import Canceled from './Canceled/Canceled';
import Pending from './Pending/Pending';
import Returned from './Returned/Returned';
import Rejected from './Rejected/Rejected';
import AddOrder from './AddOrder/AddOrder';
import GetWaybill from './GetWaybill/GetWaybill';

function OrdersIndex(props) {
  const { showMessage } = useContext(MainContext);
  const handleMessage = (color, position, title = '', content) => {
    showMessage(content, color, position);
  };
  const routes =
    props.config.childs &&
    props.config.childs.map((r, index) => {
      return (
        <Route
          exact
          path={`/protected/admin${r.path}`}
          render={(props) => {
            return (
              <r.component {...props} config={r} showMessage={handleMessage} />
            );
          }}
          key={index}
        />
      );
    });

  return (
    <Switch>
      <Route path="/protected/admin/orders/add" children={<AddOrder />} />
      <Route
        path="/protected/admin/orders/tendering/:id"
        children={<Tendering />}
      />
      <Route
        path="/protected/admin/orders/canceled/:id"
        children={<Canceled />}
      />
      <Route
        path="/protected/admin/orders/pending/:id"
        children={<Pending />}
      />
      <Route
        path="/protected/admin/orders/returned/:id"
        children={<Returned />}
      />
      <Route
        path="/protected/admin/orders/getWaybill/:id"
        children={<GetWaybill />}
      />
      <Route
        path="/protected/admin/orders/rejected/:id"
        children={<Rejected />}
      />
      <Route path="/protected/admin/orders/:id" children={<Order />} />
      <Route
        exact
        path="/protected/admin/orders"
        children={
          <Orders
            showMessage={handleMessage}
            config={props.config}
            {...props}
          />
        }
      />
      {routes}
    </Switch>
  );
}
export default OrdersIndex;
